// Loading spinner removal on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
  const loader = document.getElementById('page-gallery-loading');
  const content = document.getElementById('page-gallery-content');

  setTimeout(() => {
    if (loader) loader.remove();
    if (content) {
      content.classList.remove('opacity-0');
      content.classList.add('opacity-100');
    }
  }, 400);
});
